import { type OpenApiSchemaSectionTemplateFragment } from '#shared/api/schema';
import { type YandexKitPartialDto } from '#shared/components/YandexKitProvider';

/**
 * Маппинг фрагментов конструктора в DTO для getSettings / getAllSettings / denormalizeJsonSchema.
 *
 * @kind helper
 * @returns Массив DTO фрагментов для YandexKit
 */
export const buildConstructorPartialDtosFromFragments = (
    fragments: Record<string, OpenApiSchemaSectionTemplateFragment>
): YandexKitPartialDto[] =>
    Object.values(fragments).map((fragment) => {
        return {
            id: fragment.id,
            title: fragment.title,
            function: fragment.function,
            html: fragment.html,
            css: fragment.css,
            script: fragment.script,
            json_schema: fragment.json_schema,
        };
    });
